import React, {useState} from "react";
import './CaseButton.css'

interface ICaseButtonProps {
    selected: boolean
    title: string
    onClick: Function
    isMobile: boolean
}

export default function CaseButton(props: ICaseButtonProps) {
    return <a
        className={`${props.selected ? "Selected_case_button" : "Case_button"} ${props.isMobile ? "Case_button_mobile" : ""}`}
        onClick={(e) => props.onClick()}>
        {props.title}
    </a>
}